/**
 * What a click on the route line under the cursor would do, so the hover
 * marker can show it: add a control point to that route (`insert`), extend
 * the active route to that spot on another route (`extend`), or nothing the
 * marker should promise (`none` — over a marker, or while an area is being
 * selected). Pure; see store/modules/actions/multi-route.ts simpleHover.
 */
export type RouteHoverPreview = 'insert' | 'extend' | 'none';

export function routeHoverPreview(input: {
  hoveredRouteKey: string | null | undefined;
  activeRouteKey: string | null | undefined;
  overMarker?: boolean;
  isAreaSelecting?: boolean;
}): RouteHoverPreview {
  if (!input.hoveredRouteKey || input.overMarker || input.isAreaSelecting) return 'none';
  if (input.activeRouteKey && input.hoveredRouteKey !== input.activeRouteKey) return 'extend';
  return 'insert';
}

/** The hover source's data for a preview at `coordinates` — empty when there's nothing to promise. */
export function hoverPreviewData(kind: RouteHoverPreview, coordinates: [number, number] | number[]) {
  if (kind === 'none') return { type: 'FeatureCollection' as const, features: [] as any[] };
  return {
    type: 'FeatureCollection' as const,
    features: [{
      type: 'Feature' as const,
      geometry: { type: 'Point' as const, coordinates },
      properties: { id: 'hover-point', kind },
    }],
  };
}
